import i18next from 'i18next';

import { partialUpdateProposal } from 'common/api/v1/proposals';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DELETE_PROPOSAL,
    DELETE_PROPOSAL_FAILURE,
    DELETE_PROPOSAL_SUCCESS,
} from '../actionTypes';
import { proposalsActions } from '../reducer';

import filterProposals from './filterProposals';

export default (filterData, proposalId, value) => (dispatch) => {
    dispatch(proposalsActions[DELETE_PROPOSAL]());

    const newValues = {
        status_flag: value,
    };

    partialUpdateProposal(newValues, proposalId)
        .then((response) => {
            dispatch(proposalsActions[DELETE_PROPOSAL_SUCCESS](response.data));
            dispatch(filterProposals(filterData));
            dispatch(alerts.actions.close());
            showToast({ body: i18next.t('It was successfully removed') });
        })
        .catch((error) => {
            dispatch(
                proposalsActions[DELETE_PROPOSAL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
